<template>
  <UserShell
    title="我的申请"
    subtitle="查看个人全部申请记录与处理状态"
    :profile="profile"
    :menu-items="menuItems"
    active-key="apply"
    center-path="/user/personal"
  >
    <div class="page-actions">
      <button type="button" class="apply-entry-btn" @click="goApply">资产评估申请</button>
    </div>

    <div class="notice-box">
      <div class="notice-text">
        <div>· 当前资产类别暂定为主播资产/机构资产</div>
        <div>· 审核时间为2个工作日；审核通过后，专员将在3个工作日内电话联系你，联系电话：17882361794</div>
      </div>
    </div>

    <div class="search-row">
      <el-input v-model.trim="keyword" placeholder="请输入编号/类型/状态" class="search-input" @keyup.enter.native="handleSearch" />
      <button type="button" class="search-btn" @click="handleSearch">
		  <img src="../../assets/img/user/ss.png"/>
		  搜索
	 </button>
    </div>

    <div class="table-wrap">
      <table class="apply-table">
        <colgroup>
          <col style="width: 177px" />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr style="height: 45px">
            <th style="width: 177px">申请编号</th>
            <th>资产类别</th>
            <th>提交时间</th>
            <th>当前状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filteredRecords" :key="item.id" style="height: 55px">
            <td style="width: 177px">{{ item.applicationNo }}</td>
            <td>{{ item.assetCategory }}</td>
            <td>{{ item.submittedAt }}</td>
            <td>
              <span :class="['status-pill', statusClassMap[item.status] || 'status-draft']">{{ item.statusLabel }}</span>
            </td>
            <td>
              <div class="action-group">
                <button
                  v-for="action in getActions(item)"
                  :key="action.label"
                  type="button"
                  :class="['table-btn', action.type]"
                  @click="handleAction(action.key, item)"
                >
                  {{ action.label }}
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="!filteredRecords.length" style="height: 55px">
            <td colspan="5" class="empty-cell">暂无申请记录</td>
          </tr>
        </tbody>
      </table>
    </div>
  </UserShell>
</template>

<script>
import UserShell from './components/UserShell.vue';
import tipIcon from '@/assets/img/user/提示.png';
import { createPersonalMenu, createPersonalProfile } from './personalShared';
import { getApplications } from './personalApplicationStore';
import { downloadFile } from '@/utils/download';

export default {
  name: 'PersonalApplicationList',
  components: { UserShell },
  data() {
    return {
      tipIcon,
      profile: createPersonalProfile(),
      menuItems: createPersonalMenu(),
      keyword: '',
      searchKeyword: '',
      records: [],
      statusClassMap: {
        rejected: 'status-rejected',
        pending: 'status-reviewing',
        approved: 'status-approved',
        draft: 'status-draft'
      }
    };
  },
  computed: {
    filteredRecords() {
      if (!this.searchKeyword) {
        return this.records;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return this.records.filter(item => {
        return [item.applicationNo, item.assetCategory, item.status, item.statusLabel].some(field => String(field || '').toLowerCase().includes(keyword));
      });
    }
  },
  created() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      try {
        this.profile = createPersonalProfile();
        this.records = await getApplications({ per_page: 15 });
      } catch (error) {
        this.records = [];
        this.$message.error(error && error.message ? error.message : '获取申请列表失败');
      }
    },
    handleSearch() {
      this.searchKeyword = this.keyword;
    },
    goApply() {
      this.$router.push('/user/personal/asset-apply');
    },
    getActions(item) {
      if (item.status === 'rejected' || item.status === 'draft') {
        return [{ key: 'edit', label: '修改', type: 'primary' }];
      }
      if (item.status === 'pending') {
        return [{ key: 'view', label: '查看', type: 'ghost' }];
      }
      if (item.status === 'approved') {
		 const actions = [{ key: 'view', label: '查看', type: 'ghost' }];
        if (item.reportUrl) {
          actions.push({ key: 'download', label: '下载报告', type: 'ghost wide' });
        }
        return actions;
      }
      return [{ key: 'edit', label: '修改', type: 'primary' }];
    },
    async handleAction(action, item) {
      if (action === 'edit') {
        this.$router.push({ path: '/user/personal/asset-apply', query: { mode: 'edit', id: item.id } });
        return;
      }
      if (action === 'view') {
        this.$router.push({ path: '/user/personal/asset-apply', query: { mode: 'view', id: item.id } });
        return;
      }
      if (action === 'download') {
        if (!item.reportUrl) {
          this.$message.warning('评估报告暂未生成');
          return;
        }
        try {
          await downloadFile(item.reportUrl, `${item.applicationNo}-资产评估报告`);
        } catch (error) {
          this.$message.error(error && error.message ? error.message : '报告下载失败，请稍后重试');
        }
      }
    }
  },
  watch: {
    '$route.fullPath'() {
      this.loadRecords();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: -52px;
}

.apply-entry-btn {
 width: 144px;
 height: 46px;
 border: none;
 background: linear-gradient( 117deg, #7C83FF 0%, #8B44F4 100%);
 border-radius: 10px 10px 10px 10px;
 font-weight: 500;
 font-size: 14px;
 color: #FFFFFF;
  cursor: pointer;
  
}

.notice-box {
  display: flex;
  gap: 12px;
  margin-top: 20px;
  padding:10px 20px;
  width: 796px;
  height: 68px;
  background: #F3F3FF;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #B5A5FF;
}

.notice-text {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #7E65ED;
  line-height: 24px;
  text-align: left;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 36px;
  
 
}

.search-input {
  width: 256px;
}

.search-input ::v-deep .el-input__inner {
 width: 256px;
 height: 32px;
 background: #F7F8FA;
 border: 0;
}

.search-btn {
 width: 82px;
 height: 32px;
 background: #6F68F3;
 border-radius: 6px 6px 6px 6px;
  border: 0;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-btn img{
	margin-right: 6px;
}

.table-wrap {
  margin-top: 21px;
  border: 1px solid #d4dae8;
  border-radius: 14px;
  overflow: hidden;
}

.apply-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.apply-table thead tr {
  background: #f6f8fc;
  height: 45px;
}

.apply-table th,
.apply-table td {
  padding: 0 16px;
  border-bottom: 1px solid #E2E8F0;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #1E293B;
}

.apply-table tbody tr:last-child td {
  border-bottom: 0;
}

.apply-table th {
  font-weight: 400;
  font-size: 16px;
  color: #64748B;
  text-align: center;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  width: 70px;
  height: 30px;
  border-radius: 50px 50px 50px 50px;
}

.status-rejected {
  background: #FFDCDC;
  color: #ED2D2D;
}

.status-reviewing {
  background: #DEE8FF;
  color: #2564F6;
}

.status-approved {
  background: #ECFDF5;
  color: #059669;
}

.status-draft {
  background: #edf1f7;
  color: #6b7280;
}

.action-group {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.table-btn {
  min-width: 62px;
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  border: 0;
  font-size: 14px;
  cursor: pointer;
}

.table-btn.primary {
  background: #6f68f3;
  color: #fff;
}

.table-btn.ghost {
  background: #E6F2FF;
  color: #2564F6;
}

.table-btn.wide {
  min-width: 84px;
  background: rgba(79,70,229,0.06);
  color: #4F46E5;
  margin-right: 6px;
}

.empty-cell {
  color: #4F46E5;
}

@media (max-width: 760px) {
  .page-actions,
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-input,
  .apply-entry-btn {
    width: 100%;
  }

  .table-wrap {
    overflow-x: auto;
  }

  .apply-table {
    min-width: 760px;
  }
}
</style>
